import { DB, Storage } from "../lib";
import { defaultLocale } from "../locales";
import type { SubscriptionState } from "../subscription/types";

console.log('defaultLocale=', defaultLocale);

/**
 * Database state
 */
export interface State {
  /** Background state */
  background: BackgroundState;
  /** Widget state */
  [key: `widget/${string}`]: WidgetState | null;
  /** Plugin data */
  [key: `data/${string}`]: unknown;
  /** Whether focus has been activated */
  focus: boolean;
  /** Locale selected */
  locale: string;
  /** Time zone selected, if any */
  timeZone: string | null;
  /** Subscription state */
  subscription: SubscriptionState;
}

export interface BackgroundState {
  id: string;
  key: string;
  display: BackgroundDisplay;
}

export interface BackgroundDisplay {
  blur?: number;
  luminosity?: number;
}

export interface WidgetState {
  id: string;
  key: string;
  order: number;
  display: WidgetDisplay;
}

export interface WidgetDisplay {
  colour?: string;
  fontFamily?: string;
  fontSize?: number;
  fontWeight?: number;
  position: WidgetPosition;
  x?: number;
  y?: number; 
  className?: string;
  id: string;
}

export type WidgetPosition =
  | "topLeft"
  | "topCentre"
  | "topRight"
  | "middleLeft"
  | "middleCentre"
  | "middleRight"
  | "bottomLeft"
  | "bottomCentre"
  | "bottomRight";

// Init data for the store
const initData: State = {
  background: {
    id: "default-unsplash",
    key: "background/unsplash",
    display: {
      luminosity: -0.1,
      blur: 0,
    },
  },
  "widget/default-verse": {
    id: "default-verse",
    key: "widget/luminaverse",
    order: 0,
    display: {
      position: "middleCentre",
      id: "default-verse",
      x: Math.max(8, Math.round((window.innerWidth - Math.min(window.innerWidth * 0.92, 1180)) / 2)),
      y: Math.max(8, window.innerHeight - 200 - 40),
    },
  },
  "widget/default-weather": {
    id: "default-weather",
    key: "widget/weather",
    order: 1,
    display: {
      position: "topRight",
      id: "default-weather",
      x: 1120,
      y: 24,
    },
  },
  focus: false,
  locale: defaultLocale,
  timeZone: null,
  subscription: {
    tier: "free",
    expiresAt: null,
    stripeCustomerId: null,
  },
};

// Database storage
export const db = DB.init<State>(initData);

// Cache storage
export const cache = DB.init<Record<string, unknown | undefined>>();

// Persist data
export const dbStorage =
  BUILD_TARGET === "web"
    ? Storage.indexeddb(db, "luminaverse/config")
    : Storage.extension(db, "luminaverse/config", "local");

export const cacheStorage =
  BUILD_TARGET === "firefox"
    ? Storage.extension(cache, "luminaverse/cache", "local")
    : Storage.indexeddb(cache, "luminaverse/cache");
